var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.968.079H7.92c-.7 0-1.37.278-1.866.773-.495.495-.774 1.166-.774 1.866v2.35H3.248c-.7.002-1.37.28-1.865.775C.888 6.338.61 7.008.609 7.708v16.048c0 .7.279 1.37.774 1.865.495.495 1.166.773 1.865.774h16.048c.7 0 1.371-.278 1.866-.773.495-.495.774-1.166.775-1.866v-2.35h2.032c.7-.002 1.371-.28 1.866-.775.495-.494.773-1.165.774-1.865V2.718c0-.7-.28-1.371-.775-1.866C25.34.357 24.668.08 23.968.08zM20.29 23.756c0 .264-.105.516-.291.703-.187.186-.44.291-.703.291H3.248c-.263 0-.516-.105-.703-.291-.186-.187-.29-.44-.291-.703V7.708c0-.263.105-.516.291-.703.187-.186.44-.29.703-.291h16.048c.264 0 .516.105.703.291.186.187.291.44.291.703v16.048zm4.672-4.99c0 .264-.105.516-.291.703-.187.186-.44.29-.703.291h-2.031V7.708c-.001-.7-.28-1.37-.774-1.865-.495-.495-1.166-.773-1.866-.774H6.928V2.718c0-.264.106-.516.292-.703.186-.186.44-.291.703-.291h16.046c.264 0 .516.105.703.291.186.187.291.44.291.703v16.048z",
    fill: "#626D79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.73b452b753868e4c1db648be1d530952.svg";
export { ForwardRef as ReactComponent };